import React from 'react';
import { Layout, Typography, Image, Dropdown, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/DIGITIDE_logo.png';
import UserImg from '../../assets/images/user.svg';
import { LogoutOutlined, WalletOutlined } from '@ant-design/icons';
import axios from '../../util/axiosConfig';
import '../../styles/common.css';
import { useAuth } from '../../context/AuthContext';

const { Header } = Layout;
const { Title } = Typography;

const AppHeader: React.FC = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = async ({ key }: { key: string }) => {
    if (key === 'logout') {
      try {
        await axios.get('/api/v1/auth/signout');
        localStorage.clear()
        logout();
        navigate('/login');
      } catch (error) {
        console.error('Logout failed', error);
      }
    } else if (key === 'resetPSWD') {
      navigate('/reset-password')
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick} items={[
      {
        key: 'name',
        label: user?.username,
        disabled: false
      },
      {
        key: 'email',
        label: user?.email,
        disabled: false
      },
      {
        key: 'resetPSWD',
        icon: <WalletOutlined />,
        label: 'Reset Password',
      },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: 'Logout',
      }
    ]} />
  );

  return (
    <Header className="header-container" style={{ background: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Title level={4} className="header-title">
        Vendor Invoice Management
      </Title>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Image src={Logo} alt="Logo" className="header-logo" preview={false} />
        {location.pathname !== '/vendor-edit/verify' && 
          <Dropdown overlay={menu} trigger={['click']}>
            <Image
              src={UserImg}
              alt="user-icon"
              className="userIcon"
              preview={false}
              style={{ cursor: 'pointer', marginLeft: '16px' }}
            />
          </Dropdown>
        }
      </div>
    </Header>
  );
};

export default AppHeader;